export default "__VITE_ASSET__b3cbda8e__"